var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTypeBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 308,
    viewBox: "0 0 308 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_476_3748)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M297.817 0V307.424M0 9.60699H307.424H0ZM0 19.214H307.424H0ZM0 28.821H307.424H0ZM0 38.4279H307.424H0ZM0 48.0349H307.424H0ZM0 57.6419H307.424H0ZM0 67.2489H307.424H0ZM0 76.8559H307.424H0ZM0 86.4629H307.424H0ZM0 96.0699H307.424H0ZM0 105.677H307.424H0ZM0 115.284H307.424H0ZM0 124.891H307.424H0ZM0 134.498H307.424H0ZM0 144.105H307.424H0ZM0 153.712H307.424H0ZM0 163.319H307.424H0ZM0 172.926H307.424H0ZM0 182.533H307.424H0ZM0 192.14H307.424H0ZM0 201.747H307.424H0ZM0 211.354H307.424H0ZM0 220.961H307.424H0ZM0 230.568H307.424H0ZM0 240.175H307.424H0ZM0 249.782H307.424H0ZM0 259.389H307.424H0ZM0 268.996H307.424H0ZM0 278.603H307.424H0ZM0 288.21H307.424H0ZM0 297.817H307.424H0ZM9.60699 0V307.424V0ZM19.214 0V307.424V0ZM28.821 0V307.424V0ZM38.4279 0V307.424V0ZM48.0349 0V307.424V0ZM57.6419 0V307.424V0ZM67.2489 0V307.424V0ZM76.8559 0V307.424V0ZM86.4629 0V307.424V0ZM96.0699 0V307.424V0ZM105.677 0V307.424V0ZM115.284 0V307.424V0ZM124.891 0V307.424V0ZM134.498 0V307.424V0ZM144.105 0V307.424V0ZM153.712 0V307.424V0ZM163.319 0V307.424V0ZM172.926 0V307.424V0ZM182.533 0V307.424V0ZM192.14 0V307.424V0ZM201.747 0V307.424V0ZM211.354 0V307.424V0ZM220.961 0V307.424V0ZM230.568 0V307.424V0ZM240.175 0V307.424V0ZM249.782 0V307.424V0ZM259.389 0V307.424V0ZM268.996 0V307.424V0ZM278.603 0V307.424V0ZM288.21 0V307.424V0Z",
    stroke: "#616161",
    strokeWidth: 0.286059
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M230.568 0V307.424M0 76.8559H307.424H0ZM0 153.712H307.424H0ZM0 230.568H307.424H0ZM76.8559 0V307.424V0ZM153.712 0V307.424V0Z",
    stroke: "#616161",
    strokeWidth: 0.574627
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.424 0H0V307.424H307.424V0Z",
    stroke: "#616161",
    strokeWidth: 0.286059
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260 55H55V260H260V55Z",
    fill: "black",
    fillOpacity: 0.5,
    stroke: "#484848",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel",
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_476_3748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 308,
    height: 308,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeBg);
export default __webpack_public_path__ + "static/media/type-bg.c7f01af447e2e423ec5c187434162981.svg";
export { ForwardRef as ReactComponent };